import { StandardEvents } from '@shopify/events';

function updateDeliveryEstimates(root = document) {
  root.querySelectorAll('.fk-delivery-estimate[data-fk-delivery]').forEach((el) => {
    const txt = el.getAttribute('data-fk-delivery') || '';
    const range = txt.match(/(\d+)\s*[–-]\s*(\d+)/);
    const single = !range ? txt.match(/(\d+)/) : null;
    if (!range && !single) return;

    const min = range ? Number.parseInt(range[1], 10) : Number.parseInt(single[1], 10);
    const max = range ? Number.parseInt(range[2], 10) : min;

    const addDays = (base, days) => {
      const d = new Date(base.getFullYear(), base.getMonth(), base.getDate());
      d.setDate(d.getDate() + days);
      return d;
    };

    const fmt = (d) =>
      d.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
      });

    const now = new Date();
    const from = addDays(now, min);
    const to = addDays(now, max);
    el.textContent = 'Voraussichtlich bei Dir: ' + fmt(from) + (max !== min ? '–' + fmt(to) : '');
  });
}

function replaceProductStatus(event) {
  if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

  const section = event.target.closest('.shopify-section, dialog');
  if (!section || !('promise' in event) || !event.promise) return;

  event.promise
    .then(({ detail }) => {
      if (!detail?.html) return;

      const current = section.querySelector('.fk-product-status');
      const next = detail.html.querySelector('.fk-product-status');

      if (!current || !next) return;

      current.replaceWith(next.cloneNode(true));
      updateDeliveryEstimates(section);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[fk-product-status] Variant update failed:', error);
      }
    });
}

document.addEventListener(StandardEvents.productSelect, replaceProductStatus);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) updateDeliveryEstimates(event.target);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => updateDeliveryEstimates(document), { once: true });
} else {
  updateDeliveryEstimates(document);
}
